export default "__VITE_ASSET__gEgkKK4Q__"